export default __webpack_public_path__ + "static/media/mobility.573c1844.svg";